// extracted by mini-css-extract-plugin
module.exports = {"btn":"_1Ybmpl","btnWrap":"_2cuXZf","tenderProductDescriptionWrapper":"_1fUpjY","broad":"_3exh5K","artnummer":"_3eubSk","tenderInputWrapper__Top":"-Io5eR","wrapper":"_1SJWNK"};